/**
 * Filters out elements from each array, keeping only those with common timestamps across all arrays.
 *
 * @param {Array[]} arrays - An array of arrays, where each sub-array contains objects with a 'timestamp' field.
 * @returns {Array[]} - A filtered array of arrays with only common timestamp elements.
 */
export function reduceToCommonDates(arrays) {
  if (arrays.length === 0) return arrays;

  // Extract sets of timestamps from each array
  const timestampSets = arrays.map(arr => new Set(arr.map(item => item.timestamp)));

  // Find the intersection of all timestamp sets
  const commonTimestamps = timestampSets.reduce((commonSet, currentSet) => {
    return new Set([...commonSet].filter(timestamp => currentSet.has(timestamp)));
  });

  // Filter each array to include only elements with common timestamps
  return arrays.map(arr =>
    arr.filter(item => commonTimestamps.has(item.timestamp))
  );
}



export const rewindowSeriesToMonthly=(data)=>{
  // Sort the data array by date in ascending order
  data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  // Create an object to store the last object for each month
  const monthlyData = {};

  // Iterate over each object in the data array
  for (const obj of data) {
    const date = new Date(obj.timestamp);
    const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

    // Update the last object for the corresponding month
    monthlyData[yearMonth] = obj;
  }

  // Convert the monthlyData object to an array
  const result = Object.values(monthlyData);

  return result;
}

export const filterSeriesBetweenRange = (data, startDate, endDate, dayBuffer = 0) => {
  // Ensure startDate and endDate are valid Date objects
  const startDateObj = startDate instanceof Date ? startDate : new Date(startDate);
  const endDateObj = endDate instanceof Date ? endDate : new Date(endDate);

  // Adjust startDate and endDate by the dayBuffer
  const adjustedStartDate = new Date(startDateObj);
  adjustedStartDate.setDate(adjustedStartDate.getDate() - dayBuffer);

  const adjustedEndDate = new Date(endDateObj);
  adjustedEndDate.setDate(adjustedEndDate.getDate() + dayBuffer);

  // Filter the data array based on the adjusted timestamp range
  const filteredData = data.filter(obj => {
    const date = new Date(obj.timestamp);
    return date >= adjustedStartDate && date <= adjustedEndDate;
  });

  return filteredData;
};



export const findCommonTimestampsAndFilter = (arrays)=>{
    if (arrays.length === 0) return [];

    // Step 1: Get the set of all timestamps in the first array
    let commonTimestamps = new Set(arrays[0].map(obj => obj.timestamp));

    // Step 2: Intersect with timestamps from the other arrays
    for (let i = 1; i < arrays.length; i++) {
        const currentTimestamps = new Set(arrays[i].map(obj => obj.timestamp));
        commonTimestamps = new Set([...commonTimestamps].filter(timestamp => currentTimestamps.has(timestamp)));
    }

    // Step 3: Filter each array to keep only objects with common timestamps
    return arrays.map(array => array.filter(obj => commonTimestamps.has(obj.timestamp)));
}
